const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "100vh",
    paddingBottom: "80px", // Bottom padding for spacing
    backgroundColor: "#f5f5f5",
    width: "100%",
  },
  messagesContainer: {
    flex: 1,
    overflowY: "auto",
    paddingTop: "10px",
    paddingBottom: "10px",
    marginBottom: "10px",
    borderRadius: "4px",
    width: "100%",
    maxWidth: "100%", // Ensures it doesn't spill over
    boxSizing: "border-box", // Includes padding within the defined width
  },
  inputContainer: {
    display: "flex",
    alignItems: "center",
    backgroundColor: "white",
    marginTop: "10px",
    width: "100%", // Ensures it stays within the container's width
    flexDirection: window.innerWidth <= 1200 ? "column" : "row",
    gap: "10px",
    paddingTop: "10px", // Only vertical padding
    paddingBottom: "10px",
    boxSizing: "border-box", // Prevents padding from causing overflow
  },
  sendButton: {
    padding: "10px 20px",
    backgroundColor: "#4caf50",
    color: "white",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    width: window.innerWidth <= 1200 ? "100%" : "auto", // Full width on mobile
  },
  chatBubble: {
    padding: "10px",
    borderRadius: "10px",
    marginBottom: "10px",
    wordWrap: "break-word",
    width: "fit-content",
    maxWidth: "90%",
    boxSizing: "border-box",
  },
  userBubble: {
    backgroundColor: "#d1e7dd",
    alignSelf: "flex-end",
    marginLeft: "auto",
    marginRight: "5px",
  },
  botBubble: {
    backgroundColor: "#f0f0f0",
    alignSelf: "flex-start",
    marginRight: "5px",
  },
  textAreaInput: {
    flex: 1,
    width: "100%", // Ensures textarea takes up full width on mobile
    padding: "10px",
    border: "1px solid #ccc",
    borderRadius: "4px",
    resize: "none",
    boxSizing: "border-box", // Prevents padding from adding extra width
  },
  dropdown: {
    padding: "10px",
    border: "1px solid #ccc",
    borderRadius: "4px",
    flex: 1, // Ensures dropdowns are equal width in the mobile stacked row
    minWidth: 0, // Allows dropdown to shrink in flex layout
    width: "100%", // Ensures full width on mobile
    boxSizing: "border-box",
  },
  markdownText: {
    lineHeight: "1.5",
  },
  codeBlock: {
    fontSize: "12px",
    lineHeight: "1.5",
  },
  pre: {
    fontSize: "12px",
    lineHeight: "1.5",
  },
};

export default styles;
